<template>
  <div class="page about">
    <!-- <navigation>关于我们</navigation> -->
    <div class="about-detail">
      <img src="./images/img_01@2x.png">
      <img src="./images/img_02@2x.png">
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

.about {
  .about-detail {
    padding: 35px 30px;
    img {
      width: 100%;
      margin-bottom: 20px;
    }
  }
}</style>